import {useEffect} from 'react'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import {useHistory, useLocation} from 'react-router-dom'
import PerfilUsuario from './PerfilUsuario.page'
import PrivateRoute from '../../routes/PrivateRoute'

const UserIndex = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    window.scroll(0, 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scroll(0, 0)
    let url = location.pathname.toLowerCase()
    if (url.includes('/user/'))
      if (url === '/user/profile') return
    history.push('/404')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <BasicLayout>
      <PrivateRoute exact path='/user/profile' component={PerfilUsuario} />
    </BasicLayout>
  )
}

export default UserIndex
